// AuthorizedCallback.view.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../auth/Authorization.service";

export default function AuthorizedCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleCallback() {
      const code = new URLSearchParams(window.location.search).get("code");
      const codeVerifier = sessionStorage.getItem("pkce_code_verifier");

    /*  if (!code) {
        navigate("/login");
        return;
      }*/

       const token = AuthService.getAccessToken();

       if (!token) {
         navigate("/login");
         return;
       }  

      try {
       /* const { access_token } = await AuthService.getFirstAccessTokens({
          code,
          codeVerifier,
          redirectUri: window.location.origin + "/authorized",
        });

        AuthService.setAccessToken(access_token);*/
        navigate("/home"); // ou a página inicial desejada
      } catch (e) {
        console.error("Erro ao autenticar", e);
        navigate("/login");
      }
    }

    handleCallback();
  }, []);

  return <div>Autenticando...</div>; // loading opcional
}
